import React from "react";
import styled from "styled-components";
import { IPlayerAttributesData, ITagsData } from "../../../types/IPlayerAttributesData";
import LabelText from "../../../ui/LabelText";
import InfoIncon from "../../../assets/icons/infoicon.svg";

const StyledOverallComponents = styled.div`
width : 100% !important
display: flex;
padding: 24px 43.5px 24px 24px;
flex-direction: column;
justify-content: center;
align-items: flex-start;
gap: 16px;
flex: 1 0 0;
`;

const HeaderContent = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  & .content-text {
    color: ${({ theme }) => theme.playerColor};
    font-family: "Aeonik";
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
  }
  & .result-buttons {
    display: inline-flex;
    height: 40px;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }

  & .this-season {
    color: ${({ theme }) => theme.playerColor};
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Aeonik";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24.605px;
  }
  & .result-date {
    color: ${({ theme }) => theme.NumberColor};
    text-align: right;
    font-feature-settings: "clig" off, "liga" off;
    font-family: "DM Mono";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    text-transform: uppercase;
  }
`;

const StyledTags = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.tabBorderColor};
  .icon {
    color: ${({ theme }) => theme.NumberColor};
  }
`;

export const PlayerSmallData = styled.div<{ background: string }>`
  padding: 8px 12px 8px 12px;
  border-radius: 4px;
  background: ${({ background }) => background}; //var(--Shades-Brand-Green-2-green-2-200, #ACF8C0);
  font-family: DM Mono;
  font-size: 10px;
  font-weight: 500;
  line-height: 10px;
  text-align: center;
  & .player-data-text {
    color: #111111;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    font-family: "DM Mono";
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 10px;
    text-transform: uppercase;
  }
`;
export const EmptyData = styled.div`
  border: 1px dashed ${({ theme }) => theme.NumberColor};
  background: ${({ theme }) => theme.playerCardBackground};
`;
interface TagsComponentProps {
  tagsData: IPlayerAttributesData | undefined;
}

export const TagsComponent: React.FC<TagsComponentProps> = ({ tagsData }) => {
  return (
    <StyledOverallComponents className="common-page-css">
      <HeaderContent className="common-header">
        <h3>Tags</h3>
      </HeaderContent>
      <div className="tags">
        <StyledTags>
          <div className="tags-content-wraper">
            {tagsData?.isAttributesAvailable === false ? (
              <EmptyData className="tags-empty-data">
                <LabelText className="empty-data-text">Data not currently available</LabelText>
              </EmptyData>
            ) : tagsData?.tags === null ? (
              <EmptyData className="tags-empty-data">
                <LabelText className="empty-data-text">No tags currently apply to this player</LabelText>
              </EmptyData>
            ) : null}
            <div className="tags-centent">
              {tagsData?.tags?.map((tag, index) => (
                <PlayerSmallData key={index} background={tag.isPositive ? "#4AF075" : "#FF7900"}>
                  <span className="player-data-text">{tag.tagName}</span>
                </PlayerSmallData>
              ))}
            </div>
            <img src={InfoIncon} />
          </div>
        </StyledTags>
      </div>
    </StyledOverallComponents>
  );
};
